module.exports = __webpack_public_path__ + "static/media/bg-pattern-mobile-nav.2922ed2c.svg";